//core
import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

//styles
import { useStyles } from "../../styles";

import { ObjType } from "../../../../utils";
import RevenueShareSteps from "./RevenueShareSteps";
import {getStepsByProduct} from "../../../PaymentPlanForm/utils";

interface IRevenueShareFormProps {
  tabs: string[];
  data: ObjType[];
  type: string;
}

const RevenueShare: React.FC<IRevenueShareFormProps> = ({
  tabs,
  data,
  type,
}): JSX.Element => {
  const { t } = useTranslation();
  const styles = useStyles();

  const productsData = tabs.reduce((acc: ObjType[], item) => {
    const itemData = getStepsByProduct([...data], item);

    if (!!itemData.length) {
      acc.push({
        name: item,
        data: itemData,
      })
    }

    return acc;
  }, []);

  return (
    <Box className={styles.field}>
      <Typography variant="body2" sx={{ marginBottom: "12px", width: '100%' }}>
        {type === "revenue_share" && `${t("admin.deals.summary.revenue_share_is")}:`}
        {type === "hybrid" && `${t("admin.deals.summary.and_revenue_share_is")}:`}
      </Typography>
      <Box className={styles.fieldContent}>
        {productsData.map((item: ObjType, i: number) => {
          return (
            <RevenueShareSteps
              key={i}
              data={item.data}
              product={item.name}
              sufix={(i < (productsData.length - 1)) ? ',' : ''}
            />
          )
        })}
      </Box>
    </Box>
  );
};

export default RevenueShare;
